import { useTranslation } from 'react-i18next';
import { Text } from '@mantine/core';

import { SectionHeader, StickyContent } from 'components/shared';

export const Header = () => {
  const { t } = useTranslation('organisations');

  return (
    <StickyContent hasPageHeaderSpacings>
      <SectionHeader>{t('organisationView.header.title')}</SectionHeader>
      <Text size="md">{t('organisationView.header.description')}</Text>
    </StickyContent>
  );
};
